import { InputText } from '@dunia/ui';
import * as conditions from '@/forms/conditions';

const strToNumber = str => Number(str);

const defaultValidations = [
  {
    errorMessage: 'Please type a valid number',
    condition: conditions.isNumber,
    name: 'is-number',
  },
];

const preCondition = {
  errorMessage: 'Please type number without decimals',
  condition: conditions.isIntegerWithoutDecimals,
  name: 'is-integer-positive-no-decimals',
};


export default {
  name: 'IntegerWrapper',
  defaultValidations,
  render(createElement) {
    return createElement(InputText, {
      props: {
        ...this.$props,
        type: 'tel',
        onChange: this.handleInputChange(this.$props.onChange),
        onInstantChange: this.handleInputChange(this.$props.onInstantChange),
      },
    });
  },
  methods: {
    handleInputChange(fn) {
      return (inputValue) => {
        if (!preCondition.condition(inputValue)) {
          fn(NaN);
        } else {
          fn(strToNumber(inputValue));
        }
      };
    },
  },
  props: {
    fieldId: {
      type: String,
      required: true,
    },
    value: {},
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    errorMessage: {
      type: String,
      required: false,
    },
    isDisabled: {
      type: Boolean,
      required: true,
    },
    validationState: {
      type: String,
      required: true,
    },
    onChange: {
      type: Function,
      default: () => {},
      required: true,
    },
    onInstantChange: {
      type: Function,
      default: () => {},
      required: true,
    },
  },
};
